type LanguageCodeLabel = {
  code: string;
  label: string;
};

const languages: Record<string, LanguageCodeLabel[]> = {
  fi: [
    { code: "af", label: "afrikaans" },
    { code: "agq", label: "aghem" },
    { code: "ak", label: "akan" },
    { code: "am", label: "amhara" },
    { code: "ar", label: "arabia" },
    { code: "as", label: "assami" },
    { code: "asa", label: "asu" },
    { code: "ast", label: "asturia" },
    { code: "az", label: "azeri" },
    { code: "bas", label: "basaa" },
    { code: "be", label: "valkovenäjä" },
    { code: "bem", label: "bemba" },
    { code: "bez", label: "bena" },
    { code: "bg", label: "bulgaria" },
    { code: "bm", label: "bambara" },
    { code: "bn", label: "bengali" },
    { code: "bo", label: "tiibet" },
    { code: "br", label: "bretoni" },
    { code: "brx", label: "bodo" },
    { code: "bs", label: "bosnia" },
    { code: "ca", label: "katalaani" },
    { code: "ccp", label: "ccp" },
    { code: "ce", label: "tšetšeeni" },
    { code: "cgg", label: "kiga" },
    { code: "chr", label: "cherokee" },
    { code: "ckb", label: "sorani" },
    { code: "cs", label: "tšekki" },
    { code: "cu", label: "kirkkoslaavi" },
    { code: "cy", label: "kymri" },
    { code: "da", label: "tanska" },
    { code: "dav", label: "taita" },
    { code: "de", label: "saksa" },
    { code: "dje", label: "djerma" },
    { code: "dsb", label: "alasorbi" },
    { code: "dua", label: "duala" },
    { code: "dyo", label: "jola-fonyi" },
    { code: "dz", label: "dzongkha" },
    { code: "ebu", label: "embu" },
    { code: "ee", label: "ewe" },
    { code: "el", label: "kreikka" },
    { code: "en", label: "englanti" },
    { code: "eo", label: "esperanto" },
    { code: "es", label: "espanja" },
    { code: "et", label: "viro" },
    { code: "eu", label: "baski" },
    { code: "ewo", label: "ewondo" },
    { code: "fa", label: "persia" },
    { code: "ff", label: "fulani" },
    { code: "fi", label: "suomi" },
    { code: "fil", label: "filipino" },
    { code: "fo", label: "fääri" },
    { code: "fr", label: "ranska" },
    { code: "fur", label: "friuli" },
    { code: "fy", label: "länsifriisi" },
    { code: "ga", label: "iiri" },
    { code: "gd", label: "gaeli" },
    { code: "gl", label: "galicia" },
    { code: "gsw", label: "sveitsinsaksa" },
    { code: "gu", label: "gudžarati" },
    { code: "guz", label: "gusii" },
    { code: "gv", label: "manksi" },
    { code: "ha", label: "hausa" },
    { code: "haw", label: "havaiji" },
    { code: "hi", label: "hindi" },
    { code: "hr", label: "kroatia" },
    { code: "hsb", label: "yläsorbi" },
    { code: "hu", label: "unkari" },
    { code: "hy", label: "armenia" },
    { code: "ig", label: "igbo" },
    { code: "ii", label: "sichuanin-yi" },
    { code: "in", label: "Indonesian" },
    { code: "is", label: "islanti" },
    { code: "it", label: "italia" },
    { code: "iw", label: "heprea" },
    { code: "ja", label: "japani" },
    { code: "jgo", label: "ngomba" },
    { code: "ji", label: "Yiddish" },
    { code: "jmc", label: "machame" },
    { code: "ka", label: "georgia" },
    { code: "kab", label: "kabyyli" },
    { code: "kam", label: "kamba" },
    { code: "kde", label: "makonde" },
    { code: "kea", label: "kapverdenkreoli" },
    { code: "khq", label: "koyra chiini" },
    { code: "ki", label: "kikuju" },
    { code: "kk", label: "kazakki" },
    { code: "kkj", label: "kako" },
    { code: "kl", label: "kalaallisut" },
    { code: "kln", label: "kalenjin" },
    { code: "km", label: "khmer" },
    { code: "kn", label: "kannada" },
    { code: "ko", label: "korea" },
    { code: "kok", label: "konkani" },
    { code: "ks", label: "kašmiri" },
    { code: "ksb", label: "shambala" },
    { code: "ksf", label: "bafia" },
    { code: "ksh", label: "kölsch" },
    { code: "kw", label: "korni" },
    { code: "ky", label: "kirgiisi" },
    { code: "lag", label: "lango" },
    { code: "lb", label: "luxemburg" },
    { code: "lg", label: "ganda" },
    { code: "lkt", label: "lakota" },
    { code: "ln", label: "lingala" },
    { code: "lo", label: "lao" },
    { code: "lrc", label: "pohjoisluri" },
    { code: "lt", label: "liettua" },
    { code: "lu", label: "katanganluba" },
    { code: "luo", label: "luo" },
    { code: "luy", label: "luhya" },
    { code: "lv", label: "latvia" },
    { code: "mas", label: "maasai" },
    { code: "mer", label: "meru" },
    { code: "mfe", label: "morisyen" },
    { code: "mg", label: "malagassi" },
    { code: "mgh", label: "makua-meetto" },
    { code: "mgo", label: "meta’" },
    { code: "mk", label: "makedonia" },
    { code: "ml", label: "malajalam" },
    { code: "mn", label: "mongoli" },
    { code: "mr", label: "marathi" },
    { code: "ms", label: "malaiji" },
    { code: "mt", label: "malta" },
    { code: "mua", label: "mundang" },
    { code: "my", label: "burma" },
    { code: "mzn", label: "mazandarani" },
    { code: "naq", label: "nama" },
    { code: "nb", label: "norjan bokmål" },
    { code: "nd", label: "pohjois-ndebele" },
    { code: "nds", label: "alasaksa" },
    { code: "ne", label: "nepali" },
    { code: "nl", label: "hollanti" },
    { code: "nmg", label: "kwasio" },
    { code: "nn", label: "norjan nynorsk" },
    { code: "nnh", label: "ngiemboon" },
    { code: "no", label: "norja" },
    { code: "nus", label: "nuer" },
    { code: "nyn", label: "nyankole" },
    { code: "om", label: "oromo" },
    { code: "or", label: "orija" },
    { code: "os", label: "osseetti" },
    { code: "pa", label: "pandžabi" },
    { code: "pl", label: "puola" },
    { code: "prg", label: "muinaispreussi" },
    { code: "ps", label: "paštu" },
    { code: "pt", label: "portugali" },
    { code: "qu", label: "ketšua" },
    { code: "rm", label: "retoromaani" },
    { code: "rn", label: "rundi" },
    { code: "ro", label: "romania" },
    { code: "rof", label: "rombo" },
    { code: "ru", label: "venäjä" },
    { code: "rw", label: "ruanda" },
    { code: "rwk", label: "rwa" },
    { code: "sah", label: "jakuutti" },
    { code: "saq", label: "samburu" },
    { code: "sbp", label: "sangu" },
    { code: "sd", label: "sindhi" },
    { code: "se", label: "pohjoissaame" },
    { code: "seh", label: "sena" },
    { code: "ses", label: "koyraboro senni" },
    { code: "sg", label: "sango" },
    { code: "shi", label: "tašelhit" },
    { code: "si", label: "sinhala" },
    { code: "sk", label: "slovakki" },
    { code: "sl", label: "sloveeni" },
    { code: "smn", label: "inarinsaame" },
    { code: "sn", label: "šona" },
    { code: "so", label: "somali" },
    { code: "sq", label: "albania" },
    { code: "sr", label: "serbia" },
    { code: "sv", label: "ruotsi" },
    { code: "sw", label: "swahili" },
    { code: "ta", label: "tamili" },
    { code: "te", label: "telugu" },
    { code: "teo", label: "teso" },
    { code: "tg", label: "tadžikki" },
    { code: "th", label: "thai" },
    { code: "ti", label: "tigrinja" },
    { code: "tk", label: "turkmeeni" },
    { code: "to", label: "tonga" },
    { code: "tr", label: "turkki" },
    { code: "tt", label: "tataari" },
    { code: "twq", label: "tasawaq" },
    { code: "tzm", label: "keskiatlaksentamazight" },
    { code: "ug", label: "uiguuri" },
    { code: "uk", label: "ukraina" },
    { code: "ur", label: "urdu" },
    { code: "uz", label: "uzbekki" },
    { code: "vai", label: "vai" },
    { code: "vi", label: "vietnam" },
    { code: "vo", label: "volapük" },
    { code: "vun", label: "vunjo" },
    { code: "wae", label: "walser" },
    { code: "wo", label: "wolof" },
    { code: "xog", label: "soga" },
    { code: "yav", label: "yangben" },
    { code: "yo", label: "joruba" },
    { code: "yue", label: "kantoninkiina" },
    { code: "zgh", label: "vakioitu tamazight" },
    { code: "zh", label: "kiina" },
    { code: "zu", label: "zulu" },
  ],
  sv: [
    { code: "af", label: "afrikaans" },
    { code: "agq", label: "aghem" },
    { code: "ak", label: "akan" },
    { code: "am", label: "amhariska" },
    { code: "ar", label: "arabiska" },
    { code: "as", label: "assamesiska" },
    { code: "asa", label: "asu" },
    { code: "ast", label: "asturiska" },
    { code: "az", label: "azerbajdzjanska" },
    { code: "bas", label: "basa" },
    { code: "be", label: "vitryska" },
    { code: "bem", label: "bemba" },
    { code: "bez", label: "bena" },
    { code: "bg", label: "bulgariska" },
    { code: "bm", label: "bambara" },
    { code: "bn", label: "bengali" },
    { code: "bo", label: "tibetanska" },
    { code: "br", label: "bretonska" },
    { code: "brx", label: "bodo" },
    { code: "bs", label: "bosniska" },
    { code: "ca", label: "katalanska" },
    { code: "ccp", label: "ccp" },
    { code: "ce", label: "tjetjenska" },
    { code: "cgg", label: "chiga" },
    { code: "chr", label: "cherokesiska" },
    { code: "ckb", label: "soranisk kurdiska" },
    { code: "cs", label: "tjeckiska" },
    { code: "cu", label: "kyrkslaviska" },
    { code: "cy", label: "walesiska" },
    { code: "da", label: "danska" },
    { code: "dav", label: "taita" },
    { code: "de", label: "tyska" },
    { code: "dje", label: "zarma" },
    { code: "dsb", label: "lågsorbiska" },
    { code: "dua", label: "duala" },
    { code: "dyo", label: "jola-fonyi" },
    { code: "dz", label: "dzongkha" },
    { code: "ebu", label: "embu" },
    { code: "ee", label: "ewe" },
    { code: "el", label: "grekiska" },
    { code: "en", label: "engelska" },
    { code: "eo", label: "esperanto" },
    { code: "es", label: "spanska" },
    { code: "et", label: "estniska" },
    { code: "eu", label: "baskiska" },
    { code: "ewo", label: "ewondo" },
    { code: "fa", label: "persiska" },
    { code: "ff", label: "fulani" },
    { code: "fi", label: "finska" },
    { code: "fil", label: "filippinska" },
    { code: "fo", label: "färöiska" },
    { code: "fr", label: "franska" },
    { code: "fur", label: "friulianska" },
    { code: "fy", label: "västfrisiska" },
    { code: "ga", label: "iriska" },
    { code: "gd", label: "skotsk gäliska" },
    { code: "gl", label: "galiciska" },
    { code: "gsw", label: "schweizertyska" },
    { code: "gu", label: "gujarati" },
    { code: "guz", label: "gusii" },
    { code: "gv", label: "manx" },
    { code: "ha", label: "hausa" },
    { code: "haw", label: "hawaiiska" },
    { code: "hi", label: "hindi" },
    { code: "hr", label: "kroatiska" },
    { code: "hsb", label: "högsorbiska" },
    { code: "hu", label: "ungerska" },
    { code: "hy", label: "armeniska" },
    { code: "ig", label: "igbo" },
    { code: "ii", label: "szezuan i" },
    { code: "in", label: "indonesiska" },
    { code: "is", label: "isländska" },
    { code: "it", label: "italienska" },
    { code: "iw", label: "hebreiska" },
    { code: "ja", label: "japanska" },
    { code: "jgo", label: "ngomba" },
    { code: "ji", label: "jiddish" },
    { code: "jmc", label: "kimashami" },
    { code: "ka", label: "georgiska" },
    { code: "kab", label: "kabyliska" },
    { code: "kam", label: "kamba" },
    { code: "kde", label: "makonde" },
    { code: "kea", label: "kapverdiska" },
    { code: "khq", label: "Timbuktu-songhoy" },
    { code: "ki", label: "kikuyu" },
    { code: "kk", label: "kazakiska" },
    { code: "kkj", label: "mkako" },
    { code: "kl", label: "grönländska" },
    { code: "kln", label: "kalenjin" },
    { code: "km", label: "kambodjanska" },
    { code: "kn", label: "kannada" },
    { code: "ko", label: "koreanska" },
    { code: "kok", label: "konkani" },
    { code: "ks", label: "kashmiriska" },
    { code: "ksb", label: "kisambaa" },
    { code: "ksf", label: "bafia" },
    { code: "ksh", label: "kölniska" },
    { code: "kw", label: "korniska" },
    { code: "ky", label: "kirgisiska" },
    { code: "lag", label: "langi" },
    { code: "lb", label: "luxemburgiska" },
    { code: "lg", label: "luganda" },
    { code: "lkt", label: "lakota" },
    { code: "ln", label: "lingala" },
    { code: "lo", label: "laotiska" },
    { code: "lrc", label: "nordluri" },
    { code: "lt", label: "litauiska" },
    { code: "lu", label: "luba-katanga" },
    { code: "luo", label: "luo" },
    { code: "luy", label: "luhya" },
    { code: "lv", label: "lettiska" },
    { code: "mas", label: "massajiska" },
    { code: "mer", label: "meru" },
    { code: "mfe", label: "mauritansk kreol" },
    { code: "mg", label: "malagassiska" },
    { code: "mgh", label: "makhuwa-meetto" },
    { code: "mgo", label: "meta’" },
    { code: "mk", label: "makedonska" },
    { code: "ml", label: "malayalam" },
    { code: "mn", label: "mongoliska" },
    { code: "mr", label: "marathi" },
    { code: "ms", label: "malajiska" },
    { code: "mt", label: "maltesiska" },
    { code: "mua", label: "mundang" },
    { code: "my", label: "burmesiska" },
    { code: "mzn", label: "mazanderani" },
    { code: "naq", label: "nama" },
    { code: "nb", label: "norskt bokmål" },
    { code: "nd", label: "nordndebele" },
    { code: "nds", label: "lågtyska" },
    { code: "ne", label: "nepalesiska" },
    { code: "nl", label: "nederländska" },
    { code: "nmg", label: "kwasio" },
    { code: "nn", label: "nynorska" },
    { code: "nnh", label: "bamileké-ngiemboon" },
    { code: "no", label: "norska" },
    { code: "nus", label: "nuer" },
    { code: "nyn", label: "nyankole" },
    { code: "om", label: "oromo" },
    { code: "or", label: "oriya" },
    { code: "os", label: "ossetiska" },
    { code: "pa", label: "punjabi" },
    { code: "pl", label: "polska" },
    { code: "prg", label: "fornpreussiska" },
    { code: "ps", label: "afghanska" },
    { code: "pt", label: "portugisiska" },
    { code: "qu", label: "quechua" },
    { code: "rm", label: "rätoromanska" },
    { code: "rn", label: "rundi" },
    { code: "ro", label: "rumänska" },
    { code: "rof", label: "rombo" },
    { code: "ru", label: "ryska" },
    { code: "rw", label: "kinjarwanda" },
    { code: "rwk", label: "rwa" },
    { code: "sah", label: "jakutiska" },
    { code: "saq", label: "samburu" },
    { code: "sbp", label: "sangu" },
    { code: "sd", label: "sindhi" },
    { code: "se", label: "nordsamiska" },
    { code: "seh", label: "sena" },
    { code: "ses", label: "Gao-songhay" },
    { code: "sg", label: "sango" },
    { code: "shi", label: "tachelhit" },
    { code: "si", label: "singalesiska" },
    { code: "sk", label: "slovakiska" },
    { code: "sl", label: "slovenska" },
    { code: "smn", label: "enaresamiska" },
    { code: "sn", label: "shona" },
    { code: "so", label: "somaliska" },
    { code: "sq", label: "albanska" },
    { code: "sr", label: "serbiska" },
    { code: "sv", label: "svenska" },
    { code: "sw", label: "swahili" },
    { code: "ta", label: "tamil" },
    { code: "te", label: "telugu" },
    { code: "teo", label: "teso" },
    { code: "tg", label: "tadzjikiska" },
    { code: "th", label: "thailändska" },
    { code: "ti", label: "tigrinja" },
    { code: "tk", label: "turkmeniska" },
    { code: "to", label: "tonganska" },
    { code: "tr", label: "turkiska" },
    { code: "tt", label: "tatariska" },
    { code: "twq", label: "tasawaq" },
    { code: "tzm", label: "centralmarockansk tamazight" },
    { code: "ug", label: "uiguriska" },
    { code: "uk", label: "ukrainska" },
    { code: "ur", label: "urdu" },
    { code: "uz", label: "uzbekiska" },
    { code: "vai", label: "vaj" },
    { code: "vi", label: "vietnamesiska" },
    { code: "vo", label: "volapük" },
    { code: "vun", label: "vunjo" },
    { code: "wae", label: "walsertyska" },
    { code: "wo", label: "wolof" },
    { code: "xog", label: "lusoga" },
    { code: "yav", label: "yangben" },
    { code: "yo", label: "yoruba" },
    { code: "yue", label: "kantonesiska" },
    { code: "zgh", label: "marockansk standard-tamazight" },
    { code: "zh", label: "kinesiska" },
    { code: "zu", label: "zulu" },
  ],
  en: [
    { code: "af", label: "Afrikaans" },
    { code: "agq", label: "Aghem" },
    { code: "ak", label: "Akan" },
    { code: "am", label: "Amharic" },
    { code: "ar", label: "Arabic" },
    { code: "as", label: "Assamese" },
    { code: "asa", label: "Asu" },
    { code: "ast", label: "Asturian" },
    { code: "az", label: "Azerbaijani" },
    { code: "bas", label: "Basaa" },
    { code: "be", label: "Belarusian" },
    { code: "bem", label: "Bemba" },
    { code: "bez", label: "Bena" },
    { code: "bg", label: "Bulgarian" },
    { code: "bm", label: "Bambara" },
    { code: "bn", label: "Bangla" },
    { code: "bo", label: "Tibetan" },
    { code: "br", label: "Breton" },
    { code: "brx", label: "Bodo" },
    { code: "bs", label: "Bosnian" },
    { code: "ca", label: "Catalan" },
    { code: "ccp", label: "Chakma" },
    { code: "ce", label: "Chechen" },
    { code: "cgg", label: "Chiga" },
    { code: "chr", label: "Cherokee" },
    { code: "ckb", label: "Central Kurdish" },
    { code: "cs", label: "Czech" },
    { code: "cu", label: "Church Slavic" },
    { code: "cy", label: "Welsh" },
    { code: "da", label: "Danish" },
    { code: "dav", label: "Taita" },
    { code: "de", label: "German" },
    { code: "dje", label: "Zarma" },
    { code: "dsb", label: "Lower Sorbian" },
    { code: "dua", label: "Duala" },
    { code: "dyo", label: "Jola-Fonyi" },
    { code: "dz", label: "Dzongkha" },
    { code: "ebu", label: "Embu" },
    { code: "ee", label: "Ewe" },
    { code: "el", label: "Greek" },
    { code: "en", label: "English" },
    { code: "eo", label: "Esperanto" },
    { code: "es", label: "Spanish" },
    { code: "et", label: "Estonian" },
    { code: "eu", label: "Basque" },
    { code: "ewo", label: "Ewondo" },
    { code: "fa", label: "Persian" },
    { code: "ff", label: "Fulah" },
    { code: "fi", label: "Finnish" },
    { code: "fil", label: "Filipino" },
    { code: "fo", label: "Faroese" },
    { code: "fr", label: "French" },
    { code: "fur", label: "Friulian" },
    { code: "fy", label: "Western Frisian" },
    { code: "ga", label: "Irish" },
    { code: "gd", label: "Scottish Gaelic" },
    { code: "gl", label: "Galician" },
    { code: "gsw", label: "Swiss German" },
    { code: "gu", label: "Gujarati" },
    { code: "guz", label: "Gusii" },
    { code: "gv", label: "Manx" },
    { code: "ha", label: "Hausa" },
    { code: "haw", label: "Hawaiian" },
    { code: "hi", label: "Hindi" },
    { code: "hr", label: "Croatian" },
    { code: "hsb", label: "Upper Sorbian" },
    { code: "hu", label: "Hungarian" },
    { code: "hy", label: "Armenian" },
    { code: "ig", label: "Igbo" },
    { code: "ii", label: "Sichuan Yi" },
    { code: "in", label: "Indonesian" },
    { code: "is", label: "Icelandic" },
    { code: "it", label: "Italian" },
    { code: "iw", label: "Hebrew" },
    { code: "ja", label: "Japanese" },
    { code: "jgo", label: "Ngomba" },
    { code: "ji", label: "Yiddish" },
    { code: "jmc", label: "Machame" },
    { code: "ka", label: "Georgian" },
    { code: "kab", label: "Kabyle" },
    { code: "kam", label: "Kamba" },
    { code: "kde", label: "Makonde" },
    { code: "kea", label: "Kabuverdianu" },
    { code: "khq", label: "Koyra Chiini" },
    { code: "ki", label: "Kikuyu" },
    { code: "kk", label: "Kazakh" },
    { code: "kkj", label: "Kako" },
    { code: "kl", label: "Kalaallisut" },
    { code: "kln", label: "Kalenjin" },
    { code: "km", label: "Khmer" },
    { code: "kn", label: "Kannada" },
    { code: "ko", label: "Korean" },
    { code: "kok", label: "Konkani" },
    { code: "ks", label: "Kashmiri" },
    { code: "ksb", label: "Shambala" },
    { code: "ksf", label: "Bafia" },
    { code: "ksh", label: "Colognian" },
    { code: "kw", label: "Cornish" },
    { code: "ky", label: "Kyrgyz" },
    { code: "lag", label: "Langi" },
    { code: "lb", label: "Luxembourgish" },
    { code: "lg", label: "Ganda" },
    { code: "lkt", label: "Lakota" },
    { code: "ln", label: "Lingala" },
    { code: "lo", label: "Lao" },
    { code: "lrc", label: "Northern Luri" },
    { code: "lt", label: "Lithuanian" },
    { code: "lu", label: "Luba-Katanga" },
    { code: "luo", label: "Luo" },
    { code: "luy", label: "Luyia" },
    { code: "lv", label: "Latvian" },
    { code: "mas", label: "Masai" },
    { code: "mer", label: "Meru" },
    { code: "mfe", label: "Morisyen" },
    { code: "mg", label: "Malagasy" },
    { code: "mgh", label: "Makhuwa-Meetto" },
    { code: "mgo", label: "Metaʼ" },
    { code: "mk", label: "Macedonian" },
    { code: "ml", label: "Malayalam" },
    { code: "mn", label: "Mongolian" },
    { code: "mr", label: "Marathi" },
    { code: "ms", label: "Malay" },
    { code: "mt", label: "Maltese" },
    { code: "mua", label: "Mundang" },
    { code: "my", label: "Burmese" },
    { code: "mzn", label: "Mazanderani" },
    { code: "naq", label: "Nama" },
    { code: "nb", label: "Norwegian Bokmål" },
    { code: "nd", label: "North Ndebele" },
    { code: "nds", label: "Low German" },
    { code: "ne", label: "Nepali" },
    { code: "nl", label: "Dutch" },
    { code: "nmg", label: "Kwasio" },
    { code: "nn", label: "Norwegian Nynorsk" },
    { code: "nnh", label: "Ngiemboon" },
    { code: "no", label: "Norwegian" },
    { code: "nus", label: "Nuer" },
    { code: "nyn", label: "Nyankole" },
    { code: "om", label: "Oromo" },
    { code: "or", label: "Odia" },
    { code: "os", label: "Ossetic" },
    { code: "pa", label: "Punjabi" },
    { code: "pl", label: "Polish" },
    { code: "prg", label: "Prussian" },
    { code: "ps", label: "Pashto" },
    { code: "pt", label: "Portuguese" },
    { code: "qu", label: "Quechua" },
    { code: "rm", label: "Romansh" },
    { code: "rn", label: "Rundi" },
    { code: "ro", label: "Romanian" },
    { code: "rof", label: "Rombo" },
    { code: "ru", label: "Russian" },
    { code: "rw", label: "Kinyarwanda" },
    { code: "rwk", label: "Rwa" },
    { code: "sah", label: "Sakha" },
    { code: "saq", label: "Samburu" },
    { code: "sbp", label: "Sangu" },
    { code: "sd", label: "Sindhi" },
    { code: "se", label: "Northern Sami" },
    { code: "seh", label: "Sena" },
    { code: "ses", label: "Koyraboro Senni" },
    { code: "sg", label: "Sango" },
    { code: "shi", label: "Tachelhit" },
    { code: "si", label: "Sinhala" },
    { code: "sk", label: "Slovak" },
    { code: "sl", label: "Slovenian" },
    { code: "smn", label: "Inari Sami" },
    { code: "sn", label: "Shona" },
    { code: "so", label: "Somali" },
    { code: "sq", label: "Albanian" },
    { code: "sr", label: "Serbian" },
    { code: "sv", label: "Swedish" },
    { code: "sw", label: "Swahili" },
    { code: "ta", label: "Tamil" },
    { code: "te", label: "Telugu" },
    { code: "teo", label: "Teso" },
    { code: "tg", label: "Tajik" },
    { code: "th", label: "Thai" },
    { code: "ti", label: "Tigrinya" },
    { code: "tk", label: "Turkmen" },
    { code: "to", label: "Tongan" },
    { code: "tr", label: "Turkish" },
    { code: "tt", label: "Tatar" },
    { code: "twq", label: "Tasawaq" },
    { code: "tzm", label: "Central Atlas Tamazight" },
    { code: "ug", label: "Uyghur" },
    { code: "uk", label: "Ukrainian" },
    { code: "ur", label: "Urdu" },
    { code: "uz", label: "Uzbek" },
    { code: "vai", label: "Vai" },
    { code: "vi", label: "Vietnamese" },
    { code: "vo", label: "Volapük" },
    { code: "vun", label: "Vunjo" },
    { code: "wae", label: "Walser" },
    { code: "wo", label: "Wolof" },
    { code: "xog", label: "Soga" },
    { code: "yav", label: "Yangben" },
    { code: "yo", label: "Yoruba" },
    { code: "yue", label: "Cantonese" },
    { code: "zgh", label: "Standard Moroccan Tamazight" },
    { code: "zh", label: "Chinese" },
    { code: "zu", label: "Zulu" },
  ],
};

export default languages;
